import { Link } from 'react-router';

import { paths } from '@/app/router/paths';
import { cn, focusRing } from '@/design-system';

import { shellCopy } from './copy';

/** Dezelfde maat en vorm als `Button size="md"`, maar een echte link: hij gaat naar een adres. */
const linkBase =
    'inline-flex min-h-[44px] items-center justify-center rounded-[7px] px-4 py-[11px] font-[family-name:var(--font-body)] text-[13px] leading-none no-underline transition-colors duration-100';

const primaryLink = cn(
    linkBase,
    'bg-[var(--accent)] font-medium text-[var(--accent-text)] hover:bg-[var(--accent-hover)]',
    focusRing,
);

const outlineLink = cn(
    linkBase,
    'border border-[var(--border-control)] bg-[var(--surface-card)] text-[var(--text-primary)] hover:border-[var(--accent)] hover:text-[var(--accent)]',
    focusRing,
);

/**
 * Wat je ziet op een adres dat niet bestaat.
 *
 * Meestal is dat een oude of half overgenomen link, geen fout in de app. Daarom
 * zegt de pagina dat in gewone taal en geeft ze twee wegen verder: het dashboard
 * en Keuringen, waar je een keuring zelf weer opzoekt. Ben je niet ingelogd, dan
 * brengen die links je eerst naar het inloggen.
 */
export function NotFoundPage() {
    const copy = shellCopy.notFound;

    return (
        <main className="flex min-h-dvh items-start justify-center bg-[var(--surface-page)] px-4 py-8 sm:px-7">
            <section
                aria-labelledby="sk-not-found-title"
                className="w-full max-w-[560px] rounded-[var(--radius-card)] border border-[var(--border-default)] bg-[var(--surface-card)] p-[18px]"
            >
                <h1
                    id="sk-not-found-title"
                    className="m-0 font-[family-name:var(--font-display)] text-[24px] leading-[1.15] font-semibold tracking-[-0.02em] text-[var(--text-primary)]"
                >
                    {copy.title}
                </h1>

                <p className="mt-[10px] mb-0 text-[14px] leading-[1.5] text-[var(--text-reading)]">
                    {copy.body}
                </p>

                <p className="mt-2 mb-0 text-[13px] leading-[1.5] text-[var(--text-tertiary-safe)]">
                    {copy.next}
                </p>

                <div className="mt-[14px] flex flex-wrap gap-2">
                    <Link to={paths.dashboard} className={primaryLink}>
                        {copy.toDashboard}
                    </Link>
                    <Link to={paths.inspections} className={outlineLink}>
                        {copy.toInspections}
                    </Link>
                </div>
            </section>
        </main>
    );
}
